import { MoneyBackGuarantee } from "@/utils/miscIcons";
import s from "@/components/Misc/MoneyBack.module.scss";

const base = window?.post_template;
const moneyBackGuaranteeHeading = base?.tr_money_back_guarantee_heading;
const moneyBackGuaranteeParagraph = base?.money_back_guarantee_paragraph;
const moneyBackGuaranteeImage = base?.money_back_guarantee_image;

const MoneyBack = () => {
  return (
    <div className={s.moneybackWrapper}>
      <div className={s.moneybackImageArea}>
        {moneyBackGuaranteeImage ? (
          <img src={moneyBackGuaranteeImage} alt="30-Day Money Back Guarantee" />
        ) : (
          <MoneyBackGuarantee />
        )}
      </div>
      <div className={s.moneybackTextArea}>
        <p className={s["moneybackTextArea__heading"]}>{moneyBackGuaranteeHeading}</p>
        <div className={s["moneybackTextArea__paragraph"]}>{moneyBackGuaranteeParagraph}</div>
      </div>
    </div>
  );
};

export default MoneyBack;
